import { Link } from "react-router-dom";
import APP_ASSETS from "@/assets";
import { Topbar } from "@/components";
import { PastOrderItem } from "./PastOrders";
import { useMerchant, useOrders, useSmartWallet } from "@/contexts";
import { Skeleton } from "@/components/ui/skeleton";
import { ActiveOrders } from "@/components/active-orders";
import { OrderDrawer } from "@/components/OrderDrawer";
import { useMerchantWrite } from "@/hooks";
import { toast } from "@/components/ui/use-toast";
import { useState } from "react";
import { useAllOrdersPooling } from "@/hooks/useAllOrdersPooling";
import { getVolume } from "@/utils/aggregate";
import { Button } from "@/components/ui/button/button";
import { AssignedOrders } from "@/components/assigned-orders";
import { useSelector } from "react-redux";
import { StateStatusEnum } from "@/enums/state-status.enum";
import { trackAmplitudeEvent } from "@/utils/amplitude";

function Home() {
  const { autoOpen, setAutoOpen, resetAssignOrder } = useOrders();
  const {
    feeAccrued,
    sellPrice,
    merchantDetails,
    hasFetched: fetchedMerchantDetails,
    isLoading: fetchingMerchantDetails,
  } = useMerchant();
  const { account } = useSmartWallet();

  const { orders } = useAllOrdersPooling(account?.address);

  const onClose = () => {
    setAutoOpen(false);
  };
  const ordersData = useSelector((state: any) => state.orders.data);
  const ordersLoading = useSelector(
    (state: any) => state.orders.status == StateStatusEnum.LOADING,
  );
  const ordersFetched = useSelector(
    (state: any) => state.orders.status == StateStatusEnum.SUCCESS,
  );

  const { withdrawEarnings } = useMerchantWrite();
  console.log("ordersFetched---", ordersFetched);

  const [isWithdrawLoading, setIsWithdrawLoading] = useState(false);
  const handleWithdrawEarnings = async () => {
    setIsWithdrawLoading(true);
    trackAmplitudeEvent("WITHDRAW_EARNINGS_CLICKED");
    const result = await withdrawEarnings();
    if (result?.afterWait?.status === "success") {
      toast({
        title: "Withdrawal Successful",
        description: `Request for withdrawal submitted.`,
      });
    } else {
      toast({
        title: "Withdrawal Failed",
        description: result.message,
        variant: "destructive",
      });
    }

    setIsWithdrawLoading(false);
  };
  return (
    <main className="relative h-full max-h-[1200px] w-full max-w-[500px] bg-bg-tertiary">
      <Topbar />
      <div className="no-scrollbar h-full overflow-y-scroll pb-48 pt-12">
        <section className="flex flex-col p-6 pb-2">
          <div className="flex items-center justify-between">
            <p className="uppercase leading-5 tracking-widest text-text-light">
              Statistics
            </p>
            <Link
              to={"stats"}
              onClick={() => trackAmplitudeEvent("VIEW_ALL_STATS_CLICKED")}>
              <p className="text-sm capitalize leading-5 text-text-primary underline">
                View All
              </p>
            </Link>
          </div>
          <div className="flex items-center justify-between gap-2 py-2">
            <div className="flex h-32 w-2/5 flex-col justify-between rounded-lg border-[1px] border-stroke-primary px-3 py-4">
              <p className="text-sm text-text-primary">
                Current month <br /> volume
              </p>
              <p className="text-lg font-bold text-text-light">
                {getVolume(orders)} USDC
              </p>
            </div>
            <div className="flex h-32 w-3/5 flex-col justify-between rounded-lg border-[1px] border-stroke-primary px-3 py-4">
              <p className="text-sm text-text-primary">
                Account balance (in INR)
              </p>
              <p className="text-lg font-bold text-text-light">
                {merchantDetails ? merchantDetails?.freeAmountFiat : "-"} INR
              </p>
            </div>
          </div>
          <div className="h-30 flex flex-col justify-between gap-4 rounded-lg border-[1px] border-stroke-primary px-3 py-4">
            <div className="flex w-full items-center justify-between">
              <p className="text-sm tracking-wider text-text-primary">
                Your earnings this month
              </p>
            </div>
            <div className="flex w-full items-center justify-between gap-2">
              <div className="flex gap-2">
                <img
                  className="h-10 w-10"
                  src={APP_ASSETS.TOKENS.USDC_BLUE}
                  alt="token"
                />
                <div className="flex flex-col">
                  <p className="text-sm font-bold tracking-wide text-text-light">
                    USD Coin
                  </p>
                  <p className="font-satoshiBold text-sm tracking-wide text-gray-400">
                    USDC
                  </p>
                </div>
              </div>
              <div className="flex gap-2">
                <div className="flex flex-col items-end justify-between">
                  {!fetchingMerchantDetails ? (
                    <p className="text-md font-bold text-text-light">
                      {Number(sellPrice * feeAccrued)?.toFixed(2)}
                    </p>
                  ) : (
                    <Skeleton className="h-5 w-8" />
                  )}
                  {!fetchingMerchantDetails && fetchedMerchantDetails ? (
                    <p className="text-md font-bold text-text-light">
                      {feeAccrued?.toFixed(2)}
                    </p>
                  ) : (
                    <Skeleton className="h-5 w-8" />
                  )}
                </div>
                <div className="flex flex-col items-center justify-between">
                  <img src={APP_ASSETS.TOKENS.INR_TRANSPARENT} alt="INR" />
                  <p className="font-satoshiMedium text-sm text-gray-400">
                    USDC
                  </p>
                </div>
              </div>
            </div>
            <Button
              label={"Withdraw Earnings"}
              onClick={handleWithdrawEarnings}
              widthFull
              loading={isWithdrawLoading}
            />
          </div>
        </section>
        {/* STATISTICS */}
        {/* ACTIVE ORDERS */}
        <AssignedOrders
          newOrders={ordersData?.latestOrders?.toJS()}
          allOrders={ordersData?.allOrders?.toJS()}
          isLoading={ordersLoading}
        />
        <ActiveOrders
          activeOrders={ordersData?.activeOrders?.toJS()}
          ordersLoading={ordersLoading}
          ordersFetched={ordersFetched}
        />
        {/* ACTIVE ORDERS */}
      </div>
      {/* SCROLLABLE CONTENT */}
      {/* ABSOLUTE POSITIONED BOTTOM BAR */}
      <section className="absolute bottom-0 w-full">
        <div className="h-30 flex flex-col bg-bg-tertiary pt-2">
          <div className="mb-2 flex w-full items-center justify-between px-4">
            <p className="text-sm capitalize leading-5 text-text-primary">
              Past Orders
            </p>
            <Link
              to={"past-orders"}
              onClick={() =>
                trackAmplitudeEvent("VIEW_ALL_PAST_ORDERS_CLICKED")
              }>
              <p className="text-sm capitalize leading-5 text-text-primary underline">
                View All
              </p>
            </Link>
          </div>
          {!ordersLoading && ordersFetched ? (
            ordersData?.pastOrders?.toJS()?.length ? (
              <PastOrderItem {...ordersData?.pastOrders?.toJS()?.[0]} />
            ) : (
              <div className="flex h-16 flex-col items-center justify-center">
                <p className="text-sm leading-5 text-text-light">
                  You have no previously completed orders
                </p>
              </div>
            )
          ) : (
            <div className="flex items-center justify-center px-6 py-2">
              <Skeleton className="h-14 w-full" />
            </div>
          )}
        </div>
      </section>
      {ordersData?.assignedOrder && (
        <OrderDrawer
          autoOpen={autoOpen}
          order={ordersData?.assignedOrder}
          onClose={() => {
            onClose();
            resetAssignOrder();
          }}
          isLoading={false}
        />
      )}
      {/* ABSOLUTE POSITIONED BOTTOM BAR */}
    </main>
  );
}

export default Home;
